import { useMediaQuery } from "@mui/material";

const DEFAULT_MOBILE_BREAKPOINT = 600;

interface UseIsMobileProps {
  maxWidth?: number;
}

export function useIsMobile(props?: UseIsMobileProps): boolean {
  const { maxWidth = DEFAULT_MOBILE_BREAKPOINT } = props ?? {};
  return useMediaQuery(`(max-width:${maxWidth}px)`);
}
